import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import { BLACK, FEED_BACK, RED } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';

const STATUS_BADGE_VARIANTS = {
  BLACK: 'black',
  GREEN: 'green',
  RED: 'red',
  YELLOW: 'yellow',
};

const STATUS_BADGE_COLORS = {
  [STATUS_BADGE_VARIANTS.GREEN]: {
    background: FEED_BACK.GREEN_10,
    textAndBorder: FEED_BACK.GREEN_80,
  },
  [STATUS_BADGE_VARIANTS.YELLOW]: {
    background: FEED_BACK.YELLOW_10,
    textAndBorder: FEED_BACK.YELLOW_80,
  },
  [STATUS_BADGE_VARIANTS.BLACK]: {
    background: BLACK[10],
    textAndBorder: BLACK[100],
  },
  [STATUS_BADGE_VARIANTS.RED]: {
    background: RED[10],
    textAndBorder: RED[80],
  },
};

const StatusBadge = ({ label, variant = STATUS_BADGE_VARIANTS.BLACK, sx = {} }) => {
  const palette = STATUS_BADGE_COLORS[variant] || STATUS_BADGE_COLORS[STATUS_BADGE_VARIANTS.BLACK];

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '4px',
        width: 'fit-content',
        maxWidth: '100%',
        height: '16px',
        borderRadius: '100px',
        border: `1px solid ${palette.textAndBorder}`,
        backgroundColor: palette.background,
        padding: '0 6px',
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.5" cy="2.5" r="2.5" fill={palette.textAndBorder} />
      </svg>
      <Typography
        component="span"
        sx={{
          color: palette.textAndBorder,
          fontFamily: PRIMARY_FONT[500],
          fontSize: '12px',
          lineHeight: '12px',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

StatusBadge.propTypes = {
  label: PropTypes.string.isRequired,
  sx: PropTypes.shape({}),
  variant: PropTypes.oneOf(Object.values(STATUS_BADGE_VARIANTS)),
};

export { STATUS_BADGE_VARIANTS };
export default StatusBadge;
